import { render } from "./DefaultSpeakerSlot.vue?vue&type=template&id=be587b60&scoped=true"
import script from "./DefaultSpeakerSlot.vue?vue&type=script&lang=js"
export * from "./DefaultSpeakerSlot.vue?vue&type=script&lang=js"

import "./DefaultSpeakerSlot.vue?vue&type=style&index=0&id=be587b60&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be587b60"]])

export default __exports__